<!--
Author: TangChen
Date: 2018-11-16
Desc: 支持银行阿卡
 -->
<template>
    <div v-if="bankLists.length > 0" :class="'bizcomp-support-bank bizcomp ' + className">
        <comp-title :title="title" />
        <el-row class="support-bank" :gutter="14">
            <el-col v-for="(bank, index) in bankLists" :key="index" :span="4">
                <el-card shadow="hover">
                    <div class="bank-img">
                        <img :src="$util.getImg(bank.bankcode)" alt="" />
                        <span
                            class="k-text-flow"
                            :class="{ fonts: bank.fullname.length >= 6 }"
                            :title="bank.fullname"
                        >
                            {{ bank.fullname.toString().substr(0, 6) }}
                        </span>
                    </div>
                    <!--<p class="k-text-flow" :title="bank.bankinfo">{{bank.bankinfo}}</p>-->
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import userApi from "@/api/user";
import conf from "@/config/index";

export default {
    name: "SupportBank",
    mixins: [mixin],
    data() {
        return {
            bankLists: []
        };
    },
    mounted() {
        this.getBankInfo();
    },
    methods: {
        async getBankInfo() {
            const res = await userApi.queryPaychannel();
            if (res.data) {
                const _arr = res.data.paychannelbankInfoList ? res.data.paychannelbankInfoList : [];
                let bank = [];
                const x = {};
                // 合并银行卡
                for (let i of _arr) {
                    const _x = i.fullname.indexOf("-");
                    if (_x > -1) {
                        i.fullname = i.fullname.substring(_x + 1);
                    }
                    if (i.channelid === conf.const.TTY_CHANLEID) {
                        i.bankcode = "TTY";
                    }
                    if (!x[i.bankcode]) {
                        i.child = [];
                        i.child.push(i);
                        bank.push(i);
                        x[i.bankcode] = true;
                    } else {
                        for (let j of bank) {
                            if (j.bankcode === i.bankcode) {
                                j.child.push(i);
                            }
                        }
                    }
                }
                this.bankLists = bank;
            }
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-support-bank {
    overflow: hidden;
    .support-bank {
        padding: 20px;
        .el-col {
            margin-bottom: 10px;
        }
        .el-card__body {
            padding: 10px;
        }
        .bank-img {
            height: 30px;
            img {
                vertical-align: middle;
                width: 24px;
                height: 24px;
            }
            span {
                color: $text-color2;
                font-size: $f18;
                vertical-align: middle;
                line-height: 24px;
                margin-left: 5px;
            }
        }
        p.k-text-flow {
            color: $text-color3;
        }
    }
}
</style>
